import { render, staticRenderFns } from "./ZoomedPhoto.vue?vue&type=template&id=fcd5a3f8&scoped=true"
import script from "./ZoomedPhoto.vue?vue&type=script&lang=js"
export * from "./ZoomedPhoto.vue?vue&type=script&lang=js"
import style0 from "./ZoomedPhoto.vue?vue&type=style&index=0&id=fcd5a3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd5a3f8",
  null
  
)

export default component.exports